import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { Badge } from 'reactstrap';

const ACTIVE = 'ACTIVE';
const INACTIVE = 'INACTIVE';

const colorMapping = {
  ACTIVE: 'success',
  INACTIVE: 'danger',
};

/**
 * Active/Inactive badge.
 * @param {object} root0 props passed through to the component.
 * @param {number} root0.start unix timestamp for the start (or null).
 * @param {number} root0.finish unix timestamp for the finish (or null).
 * @param {DateTime} root0.at the point in time for which the badge will be shown as
 *                            either `active` or `inactive`.
 * @returns {React.ReactComponentElement} BadgeActive component.
 */
function BadgeActive({ start, finish, at }) {
  const intl = useIntl();

  const a = at || DateTime.now();
  const s = start ? DateTime.fromSeconds(start) : null;
  const f = finish ? DateTime.fromSeconds(finish) : null;

  const labelActive = intl.formatMessage({ id: 'badge.badge_active.active.label', defaultMessage: 'active' });
  const labelInactive = intl.formatMessage({ id: 'badge.badge_active.inactive.label', defaultMessage: 'inactive' });
  let label = labelActive;
  let colorState = ACTIVE;

  if ((s && a <= s) || (f && a > f)) {
    label = labelInactive;
    colorState = INACTIVE;
  }

  const badgeColor = colorMapping[colorState] || 'mid';

  return (
    <Badge color={badgeColor} className="badge-outline">{label.toUpperCase()}</Badge>
  );
}

BadgeActive.propTypes = {
  finish: PropTypes.number,
  start: PropTypes.number,
  at: PropTypes.instanceOf(DateTime),
};

BadgeActive.defaultProps = {
  finish: null,
  start: null,
  at: null,
};

export default BadgeActive;
